import { Component } from '@mycolorway/tao';
import { closest } from 'next/javascripts/modules/dom';
import baseMixin from './base';
import 'next/stylesheets/components/grid/cells/multi-select-cell.scss';

Component('tr-grid-multi-select-cell', {
  mixins: [baseMixin],

  properties: {
    value: {
      type: Object,
      default: [],
      observer(value) {
        if (!value || value.length === 0) this.removeAttribute('value');
      },
    },
  },

  connected() {
    this.resultChipSet = this.querySelector('tr-chip-set.selected-list');

    this.listenTo(this, {
      click: this.handleClick.bind(this),
      'tr-combo-select-field:change': this.handleChange.bind(this),
      'tr-combo-select-field:menuClosed': () => { this.editing = false; },
    });
  },

  preventClickEvent({ target }) {
    return this.editable && this.contains(target)
      && closest(target, '.selector-field-result', this);
  },

  handleClick(e) {
    if (closest(e.target, '.selector-field-result', this)) {
      this.beginEditing();
      e.stopPropagation();
    }
  },

  async beginEditing() {
    if (!this.editable || this.editing) return;

    await this.prepareEditor();
    this.destroyOverflowTooltip();
    if (!this.editor) return;

    this.editing = true;
    this.editor.focus();
    this.editor.toggleList(true);
  },

  prepareEditor() {
    return new Promise(async (resolve) => {
      if (this.editorInitialized) {
        resolve();
      } else {
        this.editor = await this.editorLoader.editor;
        this.editorInitialized = true;
        if (!this.editor) {
          resolve();
          return;
        }

        if (this.value && this.value.length > 0) {
          this.value.forEach((val) => {
            const selectedOption = this.editor
              .querySelector(`select option[value="${val}"]`);
            if (selectedOption) selectedOption.selected = true;
          });
        }

        this.listenTo(this.editor, 'tao:ready', resolve, { once: true });
        this.appendChild(this.editor);
      }
    });
  },

  getTextContentElement() {
    return this.resultChipSet;
  },

  handleChange(event) {
    this.value = event.detail;

    this.resultChipSet.removeAllChips();
    Array.from(this.editor.querySelectorAll('.result-chip-set .mdc-chip'))
      .forEach(chip => this.resultChipSet.addChip(chip.cloneNode(true)));

    this.namespacedTrigger('cellValueChange', {
      detail: { value: event.detail },
      bubbles: true,
    });
  },
});
